import moment from "moment"
import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"

import ListadoAvisosFilters from "../BBs/ListadoAvisosFilters/ListadoAvisosFilters"
import ListadoAvisosDefinitivosTable from "./BBs/ListadoAvisosDefinitivosTable/ListadoAvisosDefinitivosTable"

import Loader from "@components/ui/Loader/Loader"
import { NoticeDefinitive } from "@models/notices"
import { Box } from "@mui/material"
import { avisosService } from "@services/avisos"
import { EsfirusTablePropsPagination, HandleChangePaginationType } from "@services/hooks/useHandlerPaginationTable"
import { useSelector } from "react-redux"

const TABLE_ID = 'definitiveNotices';

const ListadoAvisosDefinitivos = () => {
  const [filters, setFilters] = useState({
    empresa: '',
    dateFrom: moment().startOf('day').add(-3, 'month'),
    dateTo: moment().startOf('day').add(1, 'day').add(-1, 'second'),
    customer: '',
    obra: '',
    empleadoDestino: '',
    empleadoOrigen: '',
    empleadoResponsable: '',
    status: '',
    type: '',
    obraIdentifier: '',
    companyObra: '',
    branch: ''
  })

  const [avisos, setAvisos] = useState<NoticeDefinitive[]>([])
  const [totalItems, setTotalItems] = useState<number>(0)
  const [loadingAvisos, setLoadingAvisos] = useState<boolean>(false)
  const [pagination, setPagination] = useState<EsfirusTablePropsPagination>({ page: 0, sizePage: 50 });
  const [availableFilters, setAvailableFilters] = useState<any>(null);
  const customFilters = useSelector((state) => (state as any).tableFilters[TABLE_ID]?.sortTable);

  useEffect(() => {
    let componentMounted = true

    const fetchAvisos = async () => {
      setLoadingAvisos(true);

      const keyMap: Record<string, string> = {
        _id: 'branch&company',
        id_definitivo: 'notification',
        date: 'date',
        time: 'time',
        customer: 'customer',
        origin_employee_name: 'origin_employee',
        destination_employee_name: 'destination_employee',
        employee_name: 'employee',
        status_name: 'status',
        notification_type_name: 'notice_type',
        description_r_791: 'description_r_791',
      };

      const orderBy = keyMap[customFilters?.field?.keymap ?? ''];
      const orderDirection = customFilters?.ascending ? 'asc' : 'desc';

      try {
        const resp = await avisosService.getList({
          from: filters.dateFrom.unix(),
          to: filters.dateTo.unix(),
          company: filters.empresa,
          customer: filters.customer,
          obra: filters.obra,
          originEmployee: filters.empleadoOrigen,
          targetEmployee: filters.empleadoDestino,
          responsibleEmployee: filters.empleadoResponsable,
          status: filters.status,
          type: filters.type,
          pagination: pagination,
          companyObra: filters.companyObra,
          branch: filters.branch,
          ...(orderBy && orderDirection ? { orderBy, orderDirection } : {})
        });

        const { items: newItems = [], total_items: newTotalItems = 0, filters: newFilters = {} } = resp?.data?.data || {};

        if (componentMounted) {
          setAvisos(newItems);
          setTotalItems(newTotalItems);
          setAvailableFilters(newFilters);
        }
      } catch {
        setAvisos([])
        setTotalItems(0)
      } finally {
        if (componentMounted) setLoadingAvisos(false)
      }
    }

    fetchAvisos()

    return () => {
      componentMounted = false
    }
  }, [filters, pagination])

  const handleChangePagination: HandleChangePaginationType = (newPaginationData) => {
    setPagination(newPaginationData)
  }

  return (
    <>
      <ListadoAvisosFilters filters={filters} setFilters={setFilters} items={avisos} availableFilters={availableFilters} />
      <ListadoAvisosDefinitivosTable
        avisos={avisos}
        pagination={pagination}
        totalItems={totalItems}
        handleChangePagination={handleChangePagination}
        tableId={TABLE_ID}
        loading={loadingAvisos}
      >
        <Box className="ml-20 mr-20 mt-40 mb-40">
          <Loader message="Cargando listado de avisos" />
        </Box>
      </ListadoAvisosDefinitivosTable>

      {/* Para cargar el modal de view y edit avisos */}
      <Outlet />
    </>
  );
}

export default ListadoAvisosDefinitivos;
